// @flow
import React, { Component } from 'react';
import { type IntlShape, injectIntl, FormattedMessage } from 'react-intl';

import localizedStrings from 'util/localizedStrings';

type Props = {
  checkboxChecked?: boolean,
  checkboxKey?: string,
  defaultPath?: string,
  disabled?: boolean,
  folderKey: string,
  handleChangeLocation: Function,
  handleToggleCheckbox?: Function,
  intl: IntlShape,
  label: Object,
  path: string,
  showCheckbox?: boolean,
};

class ServerLocationRow extends Component<Props> {
  constructor() {
    super();
    this.handleClickBrowse = this.handleClickBrowse.bind(this);
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
  }
  handleClickBrowse = event => {
    this.props.handleChangeLocation(event, this.props.folderKey);
  };
  handleClickCheckbox = event => {
    if (this.props.handleToggleCheckbox) {
      this.props.handleToggleCheckbox(event, this.props.checkboxKey);
    }
  };
  render() {
    const {
      checkboxChecked,
      checkboxKey,
      defaultPath,
      disabled = false,
      folderKey,
      intl: { formatMessage },
      label,
      path,
      showCheckbox = false,
    } = this.props;
    return (
      <div>
        <div
          className="field"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div>
            {showCheckbox && (
              <input
                checked={checkboxChecked}
                className="is-checkradio is-medium"
                id={checkboxKey}
                onChange={this.handleClickCheckbox}
                name={checkboxKey}
                type="checkbox"
              />
            )}
            <label className="label is-medium" htmlFor={checkboxKey}>
              {formatMessage(label)}
            </label>
          </div>
          <a
            className="button"
            disabled={disabled}
            onClick={this.handleClickBrowse}
            data-test-name={folderKey}
          >
            {formatMessage(localizedStrings.CHANGE)}
          </a>
        </div>
        <div className="field">
          <div className="control">
            <div className="is-indented-large has-text-black">{path}</div>
          </div>
        </div>
        <div className="help is-indented-large">
          {disabled && (
            <FormattedMessage
              {...localizedStrings.GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE}
            />
          )}
          {defaultPath && (
            <div>
              <FormattedMessage
                {...localizedStrings.SERVER_DATA_DEFAULT_VAULT_LOCATION_IS}
              />
              &nbsp; {defaultPath}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(ServerLocationRow);



// WEBPACK FOOTER //
// ./src/view/Pages/GlobalSettingsPages/ServerLocationRow.js